import { render, staticRenderFns } from "./ComboCard.vue?vue&type=template&id=1bf878e8&scoped=true&"
import script from "./ComboCard.vue?vue&type=script&lang=js&"
export * from "./ComboCard.vue?vue&type=script&lang=js&"
import style0 from "./ComboCard.vue?vue&type=style&index=0&id=1bf878e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf878e8",
  null
  
)

export default component.exports